(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_media"] && !Shopify.designMode) return;
  try {
    class MediaWithTextVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('.video__play-pause');
      if (!this.video || !this.button) return;

      this.button.addEventListener('click', () => {
        if (this.video.paused) {
          this.video.play();
        } else {
          this.video.pause();
        }
      });
      ['play', 'pause', 'ended'].forEach((type) => this.video.addEventListener(type, () => this.sync()));
      this.sync();
    }

    sync() {
      const playing = !this.video.paused && !this.video.ended;
      this.button.querySelector('[data-icon="play"]').hidden = playing;
      this.button.querySelector('[data-icon="pause"]').hidden = !playing;
    }
  }

  if (!customElements.get('media-with-text-video')) {
    customElements.define('media-with-text-video', MediaWithTextVideo);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_reveal-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('reveal-card')) {
    customElements.define(
      'reveal-card',
      class extends HTMLElement {
        connectedCallback() {
          this.onClick = this.onClick || this.toggle.bind(this);
          this.addEventListener('click', this.onClick);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
        }

        toggle() {
          const isActive = this.classList.contains('is-active');
          const scope = this.closest('.reveal-cards') || document;
          scope.querySelectorAll('reveal-card.is-active').forEach((card) => card.classList.remove('is-active'));
          if (!isActive) this.classList.add('is-active');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_social-tile"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('social-tile')) {
    customElements.define(
      'social-tile',
      class extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          if (this.video) this.observeVideo();
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          if (this.video) {
            this.video.removeEventListener('timeupdate', this.onTimeUpdate);
            this.stopVideo();
          }
        }

        observeVideo() {
          const video = this.video;
          const seconds = Number(this.dataset.autoplaySeconds || 0);
          video.muted = true;
          video.playsInline = true;
          video.loop = false;

          this.onTimeUpdate = () => {
            if (seconds <= 0 || video.paused || video.currentTime < seconds) return;
            this.playVideo();
          };
          video.addEventListener('timeupdate', this.onTimeUpdate);

          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => (entry.isIntersecting ? this.playVideo() : this.stopVideo()));
            },
            { threshold: 0.6 }
          );
          this.observer.observe(video);
        }

        stopVideo() {
          this.video.pause();
          try {
            this.video.currentTime = 0;
          } catch (error) {}
        }

        playVideo() {
          this.stopVideo();
          const playPromise = this.video.play();
          if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_video-slide"] && !Shopify.designMode) return;
  try {
    const syncCarouselVideo = (event) => {
    const video = event.target;
    if (!(video instanceof HTMLVideoElement) || !video.matches('.media-carousel__video:not([data-preview-video])')) return;

    const button = video.parentElement.querySelector('.media-carousel-video__play-pause');
    if (event.type === 'play') {
      video.setAttribute('controls', 'controls');
      video.setAttribute('data-playing', 'true');
      button?.setAttribute('data-playing', 'true');
    } else {
      video.removeAttribute('data-playing');
      button?.removeAttribute('data-playing');
    }
  };

  ['play', 'pause', 'ended'].forEach((type) => document.addEventListener(type, syncCarouselVideo, true));

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-mc-video-toggle]');
    if (button) toggleVideoPlayPause(button.dataset.mcVideoToggle, button);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-menu-accordion]');
    if (!button || window.matchMedia('(min-width: 741px)').matches) return;
    const group = button.closest('.menu-block__group');
    if (!group) return;
    const isOpen = group.classList.toggle('is-open');
    button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });
  } catch(e) { console.error(e); }
})();

})();
